import {useCallback} from 'react';
import {Conversation} from '@stripe-internal/conversations-client';
import {
  MessageFromParent,
  MessageFromParentType,
} from '../../Providers/ParentMessageBusProvider/MessageFromParent';
import {useParentMessageHandler} from '../../Providers/ParentMessageBusProvider';

export const useConversationGetSuggestedQueries = (
  conversation: Conversation,
) => {
  const handler = useCallback(
    ({type}: MessageFromParent) => {
      if (type === MessageFromParentType.GetSmartSuggestions) {
        conversation.action({name: 'get-smart-suggestions'});
      }
    },
    [conversation],
  );

  useParentMessageHandler(handler);
};
